<div class="mini-grid">
  <div class="mini-grid_title">Filter By Date 
    <span>
      <app-date-component-renderer class="date-component-border" [isGraphDataChange]="false" [currentDateFilter]="currentDateFilter"></app-date-component-renderer>
    </span>
  </div>
  <div class="mini-grid_grid-wrapper">
    <ag-grid-angular
      style="width: 100%; height: 300px"
      [ngClass]="{'mini-grid_height' : isSidePanel}"
      class="ag-theme-alpine-thin"
      [gridOptions]="gridOptions"                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
      [rowHeight]="30"
      [headerHeight]="30"
    >                                                                                                                                                                                                                                                                                                                                                                                   
    </ag-grid-angular>
  </div>
</div>
